// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Profile_Wrapper__3njLc","Profile":"Profile_Profile__3HPZ7"};